(() => {
  const el = document.getElementById('lvo-outdoor-campaign');
  if (!el || el.dataset.clockReady === 'true') return;
  el.dataset.clockReady = 'true';
  const labelsNode = document.getElementById('lvo-campaign-labels');
  const labels = labelsNode ? JSON.parse(labelsNode.textContent) : {};
  const start = Date.parse(el.dataset.start);
  const end = Date.parse(el.dataset.end);
  const show = Date.parse(el.dataset.show);
  const digits = el.querySelectorAll('[data-unit]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const update = () => {
    const now = Date.now();
    el.hidden = now < show || now >= end;
    if (el.hidden) return;
    const active = now >= start;
    const status = el.querySelector('[data-status]');
    const caption = el.querySelector('[data-caption]');
    if (status) status.textContent = active ? labels.end_label : labels.open_label;
    if (caption) caption.textContent = active ? labels.live_caption : labels.pre_caption;
    const seconds = Math.max(0, Math.ceil(((active ? end : start) - now) / 1000));
    const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
    digits.forEach((digit, index) => {
      const next = String(values[index]).padStart(2, '0');
      if (digit.textContent === next) return;
      digit.textContent = next;
      if (index === 3 && !reducedMotion.matches && digit.animate) {
        digit.getAnimations().forEach(animation => animation.cancel());
        digit.animate([
          {transform: 'translateY(-12px) scale(1.28)', opacity: 0.35},
          {transform: 'translateY(4px) scale(1.12)', opacity: 1, offset: 0.5},
          {transform: 'translateY(0) scale(1)', opacity: 1}
        ], {duration: 650, easing: 'cubic-bezier(.22,.7,.3,1)'});
      }
    });
  };
  let interval;
  const resume = () => { clearInterval(interval); update(); interval = setInterval(update, 250); };
  resume();
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', resume);
  window.addEventListener('pagehide', () => clearInterval(interval));
})();
